(ns frontend.view.modals.kpi-email.view
  (:require
   [clojure.string :as string]
   [common.localization :as loc]
   [frontend.view.modals.components.input :as input]
   [frontend.view.modals.kpi-email.events :as events]
   [reagent.core :as r]
   [ui.components.modal.view :as modal]))

(defonce modal-key :kpi-email-modal)

;;
;; Views
;;

(defn view
  [{:keys [shown? close-modal! props state topmost?]}]
  (let [{:keys [category member company cycle report-id
                send-text
                default-email-title default-email-copy
                email-title-attribute email-copy-attribute
                email-to
                send-email!]}
        props
        edit-state (r/cursor state [:edit])
        entity-atom (r/cursor state [:entity-atom])
        state-atom (r/cursor state [:state-atom])]
    (events/reset-state!
     {:state                 state
      :email-title-attribute email-title-attribute
      :email-copy-attribute  email-copy-attribute
      :default-email-title   default-email-title
      :default-email-copy    default-email-copy})
    (fn [{:keys [shown? close-modal! props state class-name topmost?]}]
      (let [{:keys [category member company cycle report-id
                    send-text
                    default-email-title default-email-copy
                    email-title-attribute email-copy-attribute
                    email-to
                    send-email!]}
            props
            state-vals @state
            {:keys [alert edit?]} state-vals
            email-title (get state-vals email-title-attribute)
            email-copy (get state-vals email-copy-attribute)
            now (js/Date.)
            edit-report @edit-state
            {:keys [kpi-cycle/target-month kpi-cycle/target-year]} cycle
            target-period-str (str target-year "/" target-month)
            cycle-name (:kpi-cycle/name cycle)
            category-id (:db/id category)
            category-name (:kpi-category/name category)
            company-name (:asset/name company)
            reset-state! (partial events/reset-state!
                                  {:state                 state
                                   :email-title-attribute email-title-attribute
                                   :email-copy-attribute  email-copy-attribute
                                   :default-email-title   default-email-title
                                   :default-email-copy    default-email-copy})
            current-email-title (get state-vals email-title-attribute)
            current-email-copy (get state-vals email-copy-attribute)
            email-title (get edit-report email-title-attribute)
            email-copy (get edit-report email-copy-attribute)
            on-cancel! (partial events/reset-state!
                                {:state                 state
                                 :email-title-attribute email-title-attribute
                                 :email-copy-attribute  email-copy-attribute
                                 :default-email-title   current-email-title
                                 :default-email-copy    current-email-copy})
            button-disabled? (or (string/blank? email-title)
                                 (string/blank? email-copy))]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close-modal!
          :backdrop      "static"
          :close-button? true}
         (loc/tr :send-reminder)
         [:div.new-kpi-report-modal
          [:div.report-modal-line
           [:span.email-to (loc/tr :email/to) ":"] " " [:span.email-address email-to]]
          [:div.report-modal-line
           [:span.email-from (loc/tr :email/from) ":"] " "
           [:span.email-address "reporting@zapflow.com"]]

          [input/simple-text-field
           {:type        :text
            :entity      edit-report
            :attribute   email-title-attribute
            :label       (loc/tr :subject)
            ;;:placeholder (loc/tr :kpi-wizard/cycle-name-placeholder)
            :read-only?  (not edit?)
            :entity-atom entity-atom
            :validate!   (fn [attribute val]
                           (swap! edit-state assoc attribute val)
                           (when (empty? val)
                             (loc/tr :error-field-not-clearable [(loc/tr attribute)])))
            :on-save!    (fn [attribute new-value on-success! on-error!]
                           ;;make sure local state is cleared when no changes:
                           (when (and (= new-value (get edit-report attribute))
                                      (fn? on-success!))
                             (on-success!))
                           (swap! edit-state assoc attribute new-value)
                           (on-success!))}]

          [input/simple-text-field
           {:type        :textarea
            :entity      edit-report
            :attribute   email-copy-attribute
            :label       (loc/tr :message)
            :entity-atom entity-atom
            :read-only?  (not edit?)
            :validate!   (fn [attribute val]
                           (swap! edit-state assoc attribute val)
                           (when (empty? val)
                             (loc/tr :error-field-not-clearable [(loc/tr attribute)])))
            :on-save!    (fn [attribute new-value on-success! on-error!]
                           ;;make sure local state is cleared when no changes:
                           (when (and (= new-value (get edit-report attribute))
                                      (fn? on-success!))
                             (on-success!))
                           (swap! edit-state assoc attribute new-value)
                           (on-success!))}]]
         [:<>
          [modal/left-cancel-only (if edit? on-cancel! close-modal!) nil]
          (when-not edit?
            [modal/left-single-button
             nil
             false
             (partial events/show-edit! state)
             (loc/tr :edit-message)])
          (if edit?
            [modal/right-single-button
             nil
             (boolean button-disabled?)
             #(events/save-email! {:state                 state
                                   :email-title-attribute email-title-attribute
                                   :email-copy-attribute  email-copy-attribute})
             (loc/tr :save)
             nil]
            [modal/right-single-button
             nil
             (boolean button-disabled?)
             #(send-email! {:msg         {:report-id            report-id
                                          email-title-attribute email-title
                                          email-copy-attribute  email-copy}
                            :on-success! close-modal!
                            :on-error!   identity})
             send-text
             nil])]]))))
